import {LangArrayToObjKeyValue} from '../../../utils/global'
import {AiOutlineEdit} from 'react-icons/ai'
import {RiDeleteBin6Line} from 'react-icons/ri'
import { useCurrent } from '../../../hooks';
import { useTranslation } from 'react-i18next';

const ListBrandsItem = ({index,el,editHandeler,deleteHandeler}) => {
  const {currentLangId} = useCurrent();
  const [t] = useTranslation('global');
  const brandNameByLang = LangArrayToObjKeyValue(el.brandName) || {};
  const brandName = brandNameByLang?.[currentLangId] || el?.brandName?.[0]?.text || el?.brandName?.[1]?.text || '-';

  return (
      <tr key={el._id} className='border-b border-slate-100 text-sm text-slate-600 transition-colors hover:bg-indigo-50/60'>
        <td className='px-3 py-3 text-center font-semibold text-slate-500'>{index}</td>
        <td className='px-3 py-3'>
          <div className='font-medium text-slate-700'>{brandName}</div>
        </td>
        <td className='px-3 py-3 text-center'>
          <span
            className={`inline-flex min-w-[140px] items-center justify-center rounded-full px-3 py-1 text-xs font-medium ${
              el.isShowOnWebsite
                ? 'bg-emerald-100 text-emerald-700'
                : 'bg-slate-200 text-slate-600'
            }`}
          >
            {el.isShowOnWebsite ? t('product.showOnWebsite') : t('product.hideOnWebsite')}
          </span>
        </td>
        <td className='px-3 py-3 text-center'>
          <span
            className={`inline-flex min-w-[90px] items-center justify-center rounded-full px-3 py-1 text-xs font-medium ${
              el.isActive
                ? 'bg-green-100 text-green-700'
                : 'bg-rose-100 text-rose-700'
            }`}
          >
            {el.isActive ? t('product.active') : t('product.inactive')}
          </span>
        </td>
        <td className='px-3 py-3'>
          <div className='flex items-center justify-center gap-2'>
            <button
              type='button'
              title={t('common.edit')}
              className='rounded-lg border border-indigo-100 p-2 text-indigo-500 transition-colors hover:border-indigo-300 hover:bg-indigo-100 hover:text-indigo-700'
              onClick={() => editHandeler(el._id)}
            >
              <AiOutlineEdit size={18} />
            </button>
            <button
              type='button'
              title={t('common.delete')}
              className='rounded-lg border border-rose-100 p-2 text-rose-500 transition-colors hover:border-rose-300 hover:bg-rose-100 hover:text-rose-700'
              onClick={() => deleteHandeler(el._id)}
            >
              <RiDeleteBin6Line size={18} />
            </button>
          </div>
        </td>
      </tr>
  );

}

export default ListBrandsItem
